import React from "react";
import { Box } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useCompany } from "../../contexts/CompanyContext";
import {
  deleteTaxRetention,
  getTaxRetentionList,
} from "../../api/accounting";
import CreateTaxRetentionForm from "./TaxRetentionForm/CreateTaxRetentionForm";
import UpdateTaxRetentionForm from "./TaxRetentionForm/UpdateTaxRetentionForm";

export default function CrudTaxRetentions() {
  const { selectedCompany } = useCompany();
  const companyId = selectedCompany?.id;
  const formatAccountCode = (account) =>
    account?.contpaqiCode || account?.compaqiCode || "-";

  const formatActivity = (activity) => {
    if (!activity) return "-";
    const accountCode = formatAccountCode(activity);
    const name = activity?.name || "-";
    return `${name} | ${accountCode}`;
  };

  if (!companyId) return null;

  return (
    <Box width={"100%"}>
      <LGModalCrud
        props={{
          actions: ["create", "update", "delete"],
          data: { companyId },
          fetchFunction: getTaxRetentionList,
          deleteFunction: deleteTaxRetention,
          search: true,
          columns: [
            {
              field: "providerType",
              headerName: "Tipo de proveedor",
              flex: 0.3,
              valueGetter: (value, row) => row?.providerType?.name || "-",
            },
            {
              field: "taxRegime",
              headerName: "Regimen fiscal",
              flex: 0.3,
              valueGetter: (value, row) => row?.taxRegime?.name || "-",
            },
            {
              field: "economicActivity",
              headerName: "Actividad economica",
              flex: 0.4,
              valueGetter: (value, row) => formatActivity(row?.economicActivity),
            },
            {
              field: "isrRetentionAccount",
              headerName: "Cuenta ISR",
              flex: 0.3,
              valueGetter: (value, row) =>
                formatAccountCode(row?.isrRetentionAccount),
            },
            {
              field: "ivaRetentionAccount",
              headerName: "Cuenta IVA",
              flex: 0.3,
              valueGetter: (value, row) =>
                formatAccountCode(row?.ivaRetentionAccount),
            },
            { field: "ivaRate", headerName: "IvaRate", flex: 0.2 },
            { field: "isrRate", headerName: "IsrRate", flex: 0.2 },
            {
              field: "description",
              headerName: "Descripcion",
              flex: 0.6,
            },
          ],
          addModalData: {
            header: "Agregar Tax Retention",
            body: <CreateTaxRetentionForm companyId={companyId} />,
          },
          editModalData: {
            header: "Editar Tax Retention",
            body: <UpdateTaxRetentionForm companyId={companyId} />,
          },
        }}
      />
    </Box>
  );
}

